import { Button, Paper, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Suspense } from 'react';
import PermissionGroupList from './PermissionGroupList';
import LoadingState from '@/components/LoadingState';

const PermissionHeader = () => {
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ pb: 2 }}
    >
      <Stack spacing={0.25}>
        <Typography variant="h3">Permission groups</Typography>
        <Typography variant="body2" color="text.secondary">
          Define grouped access rules for clinical workspace administration.
        </Typography>
      </Stack>
      <Button
        variant="contained"
        size="small"
        onClick={() => navigate('permission/group/create')}
      >
        Create Group
      </Button>
    </Stack>
  );
};

const PermissionPage = () => (
  <Stack direction="column">
    <PermissionHeader />
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <Suspense fallback={<LoadingState label="Loading permission groups…" />}>
        <PermissionGroupList />
      </Suspense>
    </Paper>
  </Stack>
);

export default PermissionPage;
